import { CONTEXT, type Area } from '@atlassian/jira-issue-view-common-types/src/connect-field-type';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (area?: Area) => area === CONTEXT;
